<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<div class="row">
		<div class="col-12">
			<h2>Mon compte</h2>

			<form [formGroup]="userInfoForm">
				<div class="form-group">
					<label class="ls-label-strong" for="username">Identifiant</label><br>
					<span style="color:red;" *ngIf="role=='A'">Vous êtes administrateur<br></span>
					<i>{{username}}</i>
				</div>

				<div class="form-group">
					<label class="ls-label-strong" for="name">Votre nom</label>
					<input #nameControl id="name" type="text" class="form-control" formControlName="nameControl" placeholder="Votre nom" ngbAutofocus (input)="nameControl.value=nameControl.value.toUpperCase()">
				</div>

				<div class="form-group">
					<label class="ls-label-strong" for="firstname">Votre prénom</label>
					<input #firstnameControl id="firstname" type="text" class="form-control" formControlName="firstnameControl" placeholder="Votre prénom" (input)="firstnameControl.value = firstnameControl.value.charAt(0).toUpperCase() + firstnameControl.value.slice(1)">
				</div>

				<div class="form-group">
					<label class="ls-label-strong" for="company">Votre société</label><br>
					<i *ngIf="company==''">Aucune société</i>
					<i *ngIf="company!=''">{{company}}</i>
				</div>
			</form>
		</div>
	</div>

	<div class="row">
		<div class="col-12">
			<button matTooltip="Enregister" mat-raised-button type="submit" class="btn btn-primary material-item" (click)="doSave()"><i class="material-icons md-24 icons">done</i> Enregistrer</button>
		</div>
	</div>

</div>
